<div class="filter-container">
    <h2>Sortierung</h2>
    <mat-form-field appearance="outline" class="full-width slim-field">
        <mat-label>Ziel</mat-label>
        <mat-select> </mat-select>
    </mat-form-field>
</div>
